const createImage = url =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', error => reject(error))
    image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
    image.src = url
  })

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} image - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 */
export default async function getCroppedImg(imageSrc, pixelCrop) {
  console.log("getCroppedImg pixel crop: "+pixelCrop);
  console.log("getCroppedImg imageSrc : "+imageSrc);
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  canvas.width = 650;
  canvas.height = 406;
  const ctx = canvas.getContext('2d')

  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(
    image,
    pixelCrop.x,pixelCrop.y,pixelCrop.width,pixelCrop.height,
    0,0,650,406
  )

  // As Base64 string
  // return canvas.toDataURL('image/jpeg');

  // As a blob
  /*return new Promise((resolve, reject) => {
    canvas.toBlob(file => {
      resolve(URL.createObjectURL(file))
    }, 'image/jpeg')
  })*/

  // As a blob
  return new Promise((resolve, reject) => {
    canvas.toBlob(file => {

      //This returns the actual blob : Use this
      resolve(file)
      //This returns the url to the blob which requires extra http call to load that blob
      // resolve(URL.createObjectURL(file))
    }, 'image/jpeg')
  })
}
